export default "__VITE_ASSET__CER_NFpa__"